import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const Title = styled.div`
  margin-bottom: 45px;

  @media screen and (max-width: 700px) {
    .react-loading-skeleton {
      max-width: 250px;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  margin-bottom: 55px;

  @media screen and (max-width: 700px) {
    .react-loading-skeleton {
      max-width: 300px;
    }
  }
`;

export const Button = styled.div``;
